import React from 'react';
import { inject } from 'mobx-react';
import { DimensionsStepTemplate } from 'themes/modules/product/wizard/pages';

@inject(i => ({
	productEditViewStore: i.rootStore.productEditViewStore,
}))
class DimensionsStep extends React.Component {
	render() {
		return <DimensionsStepTemplate {...this.props} />;
	}
}

export default DimensionsStep;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/DimensionsStep.jsx